module.exports = __webpack_public_path__ + "static/media/apple-crate.ae319bed.svg";